export const buildPaymentGatewayProfileIdentifier = (gateway, profileType, id) => `${gateway}-${profileType}-${id}`;

export function buildComponentNumbersId(componentType, componentId)
{
    return `${componentType}_${componentId}_Numbers`;
}
